"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _theming = require("../theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utilities = require("@doordash/utilities");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Inline = (0, _utilities.withDynamicTag)(_styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    margin-right: ", "px;\n  "])), _constants.BASE_STYLES, function (props) {
  return props.size;
}));
Inline.Sizes = _theming.Spacing;
Inline.propTypes = {
  size: _propTypes["default"].oneOf(Object.values(Inline.Sizes))
};
Inline.defaultProps = {
  size: _constants.BASE_SPACING
};
var _default = Inline;
exports["default"] = _default;